import { useAppSelector } from '@Src/app/hooks';

// Hook to get the display name (nickname or first name)
export const useUserDisplayName = () => {
  const nickname = useAppSelector(state => state.login.Nickname);
  const firstName = useAppSelector(state => state.login.Firstname);
  
  return nickname || firstName;
};

// Hook to get display name with proper capitalization
export const useUserDisplayNameCapitalized = () => {
  const nickname = useAppSelector(state => state.login.Nickname);
  const firstName = useAppSelector(state => state.login.Firstname);
  
  // If nickname exists, return as-is (preserve user's preferred casing)
  // If no nickname, capitalize first name
  if (nickname) {
    return nickname;
  }
  return firstName;
};

// Selector function for use in components
export const getUserDisplayName = (state: any) => {
  return state.login.Nickname || state.login.Firstname;
};